import React, { useState } from "react";
import { Link } from "react-router-dom";

export const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState({});

  const toggleDropdown = (menu) => {
    setDropdownOpen(prev => ({
      ...prev,
      [menu]: !prev[menu]
    }));
  };

  const closeAllDropdowns = () => {
    setDropdownOpen({});
    setIsMenuOpen(false);
  };

  return (
    <>
      <nav className="navbar" style={{
      backgroundColor: '#1e293b',
      borderBottom: '1px solid rgba(59, 130, 246, 0.2)',
      minHeight: '70px',
      zIndex: 9999,
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0
    }}>
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
              className="hamburger-button"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            style={{
                display: 'none',
              backgroundColor: 'transparent',
              border: '1px solid rgba(255, 255, 255, 0.3)',
              borderRadius: '4px',
              padding: '9px 10px',
              marginTop: '15px',
              marginRight: '15px'
            }}
          >
            <span className="sr-only">Toggle navigation</span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
          </button>
          <Link 
            className="navbar-brand" 
            to="/" 
            style={{ 
              display: "flex", 
              alignItems: "center",
              color: '#f8fafc',
              fontSize: '24px',
              fontWeight: '700',
              textDecoration: 'none',
              paddingTop: '15px',
              paddingBottom: '15px'
            }}
            onClick={closeAllDropdowns}
          >
            <img 
              src="/img/icon.jpg" 
              alt="DeepTeLL" 
              style={{ 
                marginRight: "12px", 
                width: "40px", 
                height: "40px",
                borderRadius: '8px'
              }} 
            />
            DeepTeLL
          </Link>
        </div>

          <div className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
            <ul className="nav-list">
              <li className="dropdown">
                <a href="#" onClick={(e) => {
                      e.preventDefault();
                      toggleDropdown('technology');
                }}>
                      技術・ソリューション <span className="caret"></span>
                    </a>
                <ul className={`dropdown-menu ${dropdownOpen.technology ? 'active' : ''}`}>
                  <li><Link to="/technology/core" onClick={closeAllDropdowns}>コア技術詳細</Link></li>
                  <li><Link to="/technology/patents" onClick={closeAllDropdowns}>特許・論文情報</Link></li>
                  <li><Link to="/technology/demo" onClick={closeAllDropdowns}>技術デモ</Link></li>
                  <li className="divider"></li>
                      <li><Link to="/solutions" onClick={closeAllDropdowns}>ソリューション一覧</Link></li>
                      <li><Link to="/solutions/industry" onClick={closeAllDropdowns}>業界別ソリューション</Link></li>
                      <li><Link to="/solutions/challenges" onClick={closeAllDropdowns}>課題別ソリューション</Link></li>
                  <li><Link to="/solutions/roi-calculator" onClick={closeAllDropdowns}>ROI計算ツール</Link></li>
                    </ul>
                  </li>
              <li><Link to="/case-studies" onClick={closeAllDropdowns}>導入事例</Link></li>
              <li className="dropdown">
                <a href="#" onClick={(e) => {
                        e.preventDefault();
                        toggleDropdown('company');
                }}>
                      企業情報 <span className="caret"></span>
                    </a>
                <ul className={`dropdown-menu ${dropdownOpen.company ? 'active' : ''}`}>
                      <li><Link to="/company/overview" onClick={closeAllDropdowns}>会社概要</Link></li>
                  <li><Link to="/company/mission" onClick={closeAllDropdowns}>ミッション・ビジョン</Link></li>
                      <li><Link to="/company/management" onClick={closeAllDropdowns}>経営陣紹介</Link></li>
                      <li><Link to="/company/rd" onClick={closeAllDropdowns}>研究開発体制</Link></li>
                  <li><Link to="/company/awards" onClick={closeAllDropdowns}>受賞歴・認証</Link></li>
                    </ul>
                  </li>
              <li className="dropdown">
                <a href="#" onClick={(e) => {
                        e.preventDefault();
                        toggleDropdown('resources');
                }}>
                      リソース <span className="caret"></span>
                    </a>
                <ul className={`dropdown-menu ${dropdownOpen.resources ? 'active' : ''}`}>
                      <li><Link to="/resources/whitepapers" onClick={closeAllDropdowns}>ホワイトペーパー</Link></li>
                      <li><Link to="/resources/technical-docs" onClick={closeAllDropdowns}>技術資料</Link></li>
                      <li><Link to="/resources/webinars" onClick={closeAllDropdowns}>ウェビナー</Link></li>
                  <li><Link to="/resources/faq" onClick={closeAllDropdowns}>FAQ</Link></li>
                  <li><Link to="/resources/glossary" onClick={closeAllDropdowns}>用語集</Link></li>
                    </ul>
                  </li>
              <li><Link to="/news" onClick={closeAllDropdowns}>ニュース・IR</Link></li>
              <li><Link to="/careers" onClick={closeAllDropdowns}>採用情報</Link></li>
              <li className="dropdown">
                <a href="#" onClick={(e) => {
                        e.preventDefault();
                        toggleDropdown('contact');
                }}>
                      お問い合わせ <span className="caret"></span>
                    </a>
                <ul className={`dropdown-menu ${dropdownOpen.contact ? 'active' : ''}`}>
                      <li><Link to="/contact/general" onClick={closeAllDropdowns}>一般問い合わせ</Link></li>
                      <li><Link to="/contact/materials" onClick={closeAllDropdowns}>資料請求</Link></li>
                      <li><Link to="/contact/demo" onClick={closeAllDropdowns}>デモ申し込み</Link></li>
                  <li><Link to="/contact/partnership" onClick={closeAllDropdowns}>パートナーシップ</Link></li>
                    </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>

      <style jsx>{`
        .navbar {
          display: flex;
          align-items: center;
        }

        .container {
          width: 100%;
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 15px;
        }

        .nav-menu {
          display: flex;
          align-items: center;
        }

        .nav-list {
          display: flex;
          list-style: none;
          margin: 0;
          padding: 0;
        }

        .nav-list li {
          position: relative;
        }

        .nav-list a,
        .nav-list a:link,
        .nav-list a:visited {
          color: #cbd5e1 !important;
          text-decoration: none;
          padding: 15px 20px;
          display: block;
          font-size: 16px;
          font-weight: 500;
          transition: all 0.3s;
          background-color: transparent;
        }

        .nav-list a:hover,
        .nav-list a:focus {
          color: #f8fafc !important;
          background-color: #0F172A !important;
        }
        
        .dropdown-menu {
          display: none;
          position: absolute;
          top: 100%;
          left: 0;
          background-color: #1e293b;
          border: 1px solid rgba(59, 130, 246, 0.2);
          border-radius: 4px;
          min-width: 200px;
          box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
        }
        
        .dropdown-menu.active {
          display: block;
        }
        
        .dropdown-menu li {
          display: block;
        }

        .dropdown-menu a,
        .dropdown-menu a:link,
        .dropdown-menu a:visited {
          padding: 8px 20px;
          font-size: 14px;
          display: block;
          color: #cbd5e1 !important;
          background-color: transparent;
          transition: all 0.3s;
        }
        
        .dropdown-menu a:hover,
        .dropdown-menu a:focus {
          color: #f8fafc !important;
          background-color: #0F172A !important;
        }

        .divider {
          height: 1px;
          background-color: rgba(59, 130, 246, 0.2);
          margin: 8px 0;
          display: block;
        }

        .home-button {
          background-color: #3b82f6;
          color: white !important;
          border: 1px solid #3b82f6;
          border-radius: 4px;
          padding: 6px 12px !important;
          font-size: 14px;
          margin: 8px 10px;
        }
        
        .caret {
          display: inline-block;
          width: 0;
          height: 0;
          margin-left: 2px;
          vertical-align: middle;
          border-top: 4px solid;
          border-right: 4px solid transparent;
          border-left: 4px solid transparent;
        }
        
        .icon-bar {
          background-color: #f8fafc;
          display: block;
          width: 22px;
          height: 2px;
          border-radius: 1px;
          margin-bottom: 4px;
        }

        .icon-bar:last-child {
          margin-bottom: 0;
        }
        
        @media (max-width: 768px) {
          .hamburger-button {
            display: block !important;
          }
          
          .nav-menu {
            display: none;
            position: absolute;
            top: 70px;
            left: 0;
            right: 0;
            background-color: #1e293b;
            padding: 20px;
          }
          
          .nav-menu.active {
            display: block;
          }
          
          .nav-list {
            display: block;
            flex-direction: column;
          }
          
          .nav-list li {
            display: block;
          }
          
          .dropdown-menu {
            position: static;
            display: block;
            box-shadow: none;
            border: none;
            background-color: rgba(30, 41, 59, 0.9);
          }
          
          .dropdown-menu a {
            padding-left: 40px;
          }
        }
      `}</style>
    </>
  );
};
